/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailHealthResponseDto
 */
export interface EmailHealthResponseDto {
    /**
     * Whether the email service is connected
     * @type {boolean}
     * @memberof EmailHealthResponseDto
     */
    connected: boolean;
    /**
     * Status message
     * @type {string}
     * @memberof EmailHealthResponseDto
     */
    message: string;
}

/**
 * Check if a given object implements the EmailHealthResponseDto interface.
 */
export function instanceOfEmailHealthResponseDto(value: object): value is EmailHealthResponseDto {
    if (!('connected' in value) || value['connected'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function EmailHealthResponseDtoFromJSON(json: any): EmailHealthResponseDto {
    return EmailHealthResponseDtoFromJSONTyped(json, false);
}

export function EmailHealthResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailHealthResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'connected': json['connected'],
        'message': json['message'],
    };
}

export function EmailHealthResponseDtoToJSON(json: any): EmailHealthResponseDto {
    return EmailHealthResponseDtoToJSONTyped(json, false);
}

export function EmailHealthResponseDtoToJSONTyped(value?: EmailHealthResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'connected': value['connected'],
        'message': value['message'],
    };
}

